import type { PropsWithChildren } from 'react';

import { Badge } from '@/components/Badge';
import { HStack, VStack } from '@/components/Layout';
import { defaultNS, useTranslation } from '@/lib/i18n';

export type PrimaryLabelKey = 'primary' | 'hrPrimary';

export default function MultiValueCell(props: PropsWithChildren) {
  return <VStack className="gap-1">{props.children}</VStack>;
}

export function MultiValueCellRow(
  props: PropsWithChildren<{
    isPrimary?: boolean;
    primaryLabelKey?: PrimaryLabelKey;
  }>,
) {
  const { isPrimary, children, primaryLabelKey = 'primary' } = props;

  const { t } = useTranslation(defaultNS, {
    keyPrefix: 'component.dataTable.cells.MultiValueCell',
  });

  return (
    <HStack className="items-center gap-2 text-nowrap">
      {children}
      {isPrimary && <Badge variant="secondary">{t(primaryLabelKey)}</Badge>}
    </HStack>
  );
}
